import type { printOnDemand, ID } from "common/utils/models";
import { XCircle } from "lucide-react";
import { Button } from "@design-lab/shared/ui";
import { cn } from "tailwind-variants";

type CanvasProductCompositionsProps = {
  composition: printOnDemand.getProduct.Composition;
  isSelected: boolean;
  onSelect: (id: ID) => void;
  onRemove?: ((id: ID) => void) | undefined;
};

export function CanvasProductCompositions(props: CanvasProductCompositionsProps) {
  const { composition, isSelected, onSelect, onRemove } = props;

  const shirtImage =
    composition.surfaces?.front?.picture || composition.surfaces?.frontLeftChest?.picture;

  const handleRemove = () => {
    if (onRemove) {
      onRemove(composition.id);
    }
  };

  return (
    <div className="relative">
      {shirtImage && (
        <>
          <button
            type="button"
            data-testid="canvas-product-composition"
            aria-pressed={isSelected}
            className="block rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
            onClick={() => onSelect(composition.id)}
          >
            <img
              src={shirtImage}
              alt={composition.colorName}
              className={cn(
                "size-10 rounded-lg border-2 border-gray-300 object-contain",
                isSelected && "border-black shadow-md"
              )}
            />
          </button>
          {onRemove && (
            <Button
              variant="icon"
              className="bg-background absolute -right-1.5 -top-1.5 size-4 rounded-full p-0.5 shadow-md"
              aria-label="Remove product"
              onPress={handleRemove}
              data-testid="canvas-remove-product-button"
            >
              <XCircle className="size-4 text-red-600" />
            </Button>
          )}
        </>
      )}
    </div>
  );
}
